import { render } from "./LandingServiceName.vue?vue&type=template&id=3adbe394&scoped=true"
import script from "./LandingServiceName.vue?vue&type=script&lang=js"
export * from "./LandingServiceName.vue?vue&type=script&lang=js"

import "./LandingServiceName.vue?vue&type=style&index=0&id=3adbe394&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-3adbe394"]])

export default __exports__